import type { User } from 'Types/user';
import type { Nullable } from 'Types/utils';

import useUser from './useUser';

export const checkIsMobilizePartner = (user: User | { isLoggedOut: true }): boolean => {
	if (!('partners' in user) || !user.partners?.length) return false;
	return user.partners.includes('mobilize');
};

export const checkIsMobilizeEnquiry = (sourcePartner: Nullable<string>): boolean => sourcePartner === 'mobilize';

const useCheckIsMobilizePartner = (): boolean => {
	const user = useUser();
	return checkIsMobilizePartner(user);
};

export default useCheckIsMobilizePartner;
